import React, { useState } from "react";

const ChipInput = ({ options, onChange, selected }) => {
  const handleClick = (option) => {
    onChange && onChange(option);
  };

  return (
    <div className="flex flex-wrap items-center gap-4 w-full">
      {options.map((option, idx) => (
        <button
          key={idx}
          type="button"
          onClick={() => handleClick(option.value)}
          className={`flex-1 min-w-[200px] px-4 py-2 text-sm rounded-md border transition-colors
            ${
              selected === option.value
                ? "border-[#de2b26] bg-[#de2b26] text-[#fff]"
                : "border-gray-300 bg-white text-gray-700 hover:border-gray-400"
            }`}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};

export default ChipInput;
